import type { ToastMessageOptions } from 'primevue';
import { useToast as usePrimeToast } from 'primevue/usetoast';

type ToastFn = (
  summary: string,
  detail?: string,
  options?: Omit<ToastMessageOptions, 'severity' | 'summary' | 'detail'>,
) => void;

export type Toast = {
  success: ToastFn;
  error: ToastFn;
  warn: ToastFn;
  info: ToastFn;
};

export function useToast(): Toast {
  const toast = usePrimeToast();

  return {
    success: (summary, detail, options = { life: 2200 }) =>
      toast.add({ severity: 'success', summary, detail, ...options }),
    error: (summary, detail, options = { life: 5000 }) =>
      toast.add({ severity: 'error', summary, detail, ...options }),
    warn: (summary, detail, options = { life: 4000 }) =>
      toast.add({ severity: 'warn', summary, detail, ...options }),
    info: (summary, detail, options = { life: 3000 }) =>
      toast.add({ severity: 'info', summary, detail, ...options }),
  };
}
